
import { TransferAssetEntityDecoratorBase } from './transfer-asset.decorator.base';


export class TransferAssetEntityDecorator extends TransferAssetEntityDecoratorBase {
  constructor() {
    super();
  }
}



